import { http } from '../utils/http'

// groovyManagement 查询
const searchAction = (params, page, size) => {
    const url = `/config/groovyScript/page`
    return http.post(url, params, page, size)
};

// groovyManagement 新增/修改
const addAction = (params) => {
    const url = `/config/groovyScript/save`
    return http.post(url, params)
};

// groovyManagement 获取详情
const getInfoAction = (id) => {
    const url = `/config/groovyScript/get/${id}`
    return http.post(url)
};

// groovyManagement 锁定
const lockAction = (params) => {
    const url = `/config/groovyScript/changeStatus`
    return http.post(url, params)
};

// 导入
const importAction = (params) => {
    const url = `/config/groovyScript/import`
    return http.post(url, params)
};

// 导出
const exportAction = (params) => {
    const url = `/config/groovyScript/export`
    return http.post(url, params)
};

// version 列表
const ViewAction = (id) => {
    const url = `/config/groovyScriptVersion/listByGroovyId/${id}`
    return http.post(url)
};

// version 详情
const ViewInfoAction = (id) => {
    const url = `/config/groovyScriptVersion/get/${id}`
    return http.post(url)
};

export default {
    searchAction,
    addAction,
    lockAction,
    importAction,
    exportAction,
    getInfoAction,
    ViewAction,
    ViewInfoAction
  }